import {Core} from './ThemeInterface';
import MessageType from '../enums/MessageType';
import MessageIcons from '../enums/MessageIcons';

export default {
  brand: '#000',
  accent: '#898b8e',
  background: '#fff',
  foreground: '#000',
  neutral: '#f4f4f1',
  border: '#dad9d7',
  
  boldFontWeight: 700,
  typography: {
    primary: 'Arial, sans-serif',
    secondary: 'Arial, sans-serif',
  },
  
  messageColours: {
    [MessageType.INFO]: {
      foreground: '#0065ad',
      background: '#e6f0f8',
    },
    [MessageType.SUCCESS]: {
      foreground: '#007831',
      background: '#e6f2ea',
    },
    [MessageType.ERROR]: {
      foreground: '#C42C21',
      background: '#fae8e6',
    },
  },
  
  messageIconStyles: {
    [MessageType.INFO]: MessageIcons.DEFAULT,
    [MessageType.SUCCESS]: MessageIcons.DEFAULT,
    [MessageType.ERROR]: MessageIcons.DEFAULT,
  },
} as Core;
